import {HttpExclude, RequestExpose} from '@simpli/serialized-request'
import {ExpansibleCollection} from '@simpli/resource-collection'
import axios from 'axios'
import {GMNftCollection} from '@/model/resource/GhostMarket/GMNftCollection'
import {EnvHelper} from '@/helpers/EnvHelper'

@HttpExclude()
export class GMNftCollectionCollection extends ExpansibleCollection<
  GMNftCollection
> {
  resource?: IGMNftCollectionCollectionResourceHolder

  @RequestExpose() ownerAddress: string | null = null
  @RequestExpose() ownersChains: string | null = null

  constructor() {
    super(GMNftCollection)
  }

  queryAsPage() {
    return this.listNftCollectionCollection()
  }

  async listNftCollectionCollection(): Promise<void> {
    const baseUrl = `${EnvHelper.VUE_APP_BASE_GHOSTMARKET_URL}collections`
    const params = new URLSearchParams()

    if (this.ownerAddress) {
      params.append('owners[]', this.ownerAddress)
    }

    if (this.ownersChains) {
      params.append('ownersChains[]', this.ownersChains)
    }

    const url = `${baseUrl}?${params.toString()}`

    const {data} = await axios.get(url)

    const items = data.collections.map((collection: any) => {
      const nftCollection = new GMNftCollection()

      nftCollection.name = collection.name
      nftCollection.slug = collection.slug

      return nftCollection
    })

    this.items = items
  }
}

export interface IGMNftCollectionCollectionResourceHolder {}
